import React from 'react';
import moment from 'moment';
import DatePicker from 'components/common/DatePicker';
import { DATE_FORMATS } from 'utils/dateTime';
import styles from './styles.module.scss';

export interface ICalendarProps {
  selectedDate: Date | null;
  excludeDates: Date[];
  onSelectDate: (date: Date) => void;
  minDate: Date;
  maxDate: Date;
}

const Calendar = (props: ICalendarProps) => {
  const { selectedDate, onSelectDate, excludeDates, minDate, maxDate } = props;
  return (
    <div className={styles.wrapper}>
      <div
        id="appointment-compliance-modal"
        className={styles.calendar}
        data-testid="urine-drug-calendar"
      >
        <DatePicker
          selected={selectedDate}
          onSelect={onSelectDate}
          minDate={minDate}
          maxDate={maxDate}
          excludeDates={excludeDates}
        />
        <div data-testid="selected-date-text" className={styles['text-date']}>
          {selectedDate
            ? moment(selectedDate!).format(DATE_FORMATS.dddd_MMMM_D)
            : ''}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
